interface Props {
  type: string;
  top?: number;
  textClass?: string;
}

export const TypePill = ({ type = '', top = -20, textClass = '' }: Props) => {
  return (
    <div className="flex-center-center-column-nowrap" style={{ position: 'relative' }}>
      <div className={`text-shade normalText3 ${textClass}`} style={{ position: 'absolute', top }}>
        {type}
      </div>
    </div>
  );
};
